import React, {Fragment} from 'react';
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import FormHeader from "../../Common/FormHeader";
import ListTable from "../../Common/ListTable";
import {
    loadCustomFormData,
    decodeString,
    showToast,
    convertUTCToLocalTime,
    replaceSymbolsToHtml
} from "../../Common/Appcommon";
import CratioTooltip from "../../Common/CratioTooltip";
import QuickReplyOperations from './QuickReplyOperations';
import { randstr, parseJSON ,handleErrorResponse} from '../../Common/Appcommon';
import requestApi from "../../services/requestApi.service";
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";


class QuickReply extends React.Component {

    formname = process.env.REACT_APP_QUICKREPLY_FORMNAME;

    constructor(props) {
        super(props);

        const type = props.type || `quick-reply`;

        this.state = {
            page:1,
            limit: process.env.REACT_APP_RECORDS_PER_PAGE,
            totalCount: 0,
            formData: [],
            listFields : [],
            otherInfo : [],
            showActionModal : false,
            quickReplyId : '',
            type : type,
            customCondition : `Type#${type}`,
            inboxStatus : [],
            filterTxt: []
        }
    }

    componentDidMount = async () => {
        await this.loadFormData();
        await this.getInboxSettingsDetails();
    };

    loadFormData = async (issearch=false) => {
        const { rowData , listFields, totalCount, otherInfo } =
            await loadCustomFormData(
                issearch,
                this.formname,
                this.state
            );
        this.setState({
            formData: rowData,
            listFields : listFields,
            totalCount : totalCount,
            otherInfo : otherInfo,
        })
    }
    getInboxSettingsDetails = async () => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "AUTO_REPLY_DETAILS",
        };
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let res = response.data;
            this.setState({
                inboxStatus: res === true ? 'Yes' : 'No',
            })
        }
    }
    onPageChange = async (page) => {
        this.setState({page},async ()=>{
            await this.loadFormData();
        });
    }
    renderElements = (name,formData) => {
        if(name === 'groupName'){
            let nameValue = formData['Name'];
            let titleValue = formData['Title'];
            let updatedOn = formData['updatedon'];
            let createdBy = formData['Created Username'];
            let tooltiptxt = "Last Updated User/ Time";
            if(this.state.type === "quick-reply"){
                titleValue = nameValue;
            }

            if(updatedOn !== "" && updatedOn !== null){
                updatedOn = convertUTCToLocalTime(updatedOn);
            }

            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-message'}>{titleValue}</span>
                        <CratioTooltip title={tooltiptxt} content={<span className={'template-secondary'}>{createdBy}, {updatedOn}</span>} />
                    </div>
                </>
            )
        }else if(name === 'msgGroup'){
            let message = formData['Message'];
            if(message !== "") {
                message = decodeString(message,true);
                if(typeof message === "string") {
                    message = message.replace(/\\n/g, '');
                }else if(typeof message === "object" && Object.keys(message).length === 0) {
                    message = "";
                }

                if(message !== undefined && message !== "" && message !== null){
                    message = replaceSymbolsToHtml(message);
                }
            }
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'text-left'}>{message}</span>
                    </div>
                </>
            )
        }else if(name === 'InputValue'){

            let Input = "";
            let Name = formData['Name'] !== undefined && formData['Name'] !== '' ? formData['Name'] : '';
            if(formData['Input'] !== undefined){
                if(formData['Input'] !== "" && formData['Input'] !== null){
                    Input = parseJSON(formData['Input']);
                    if(Input.length > 0){
                        Input = ', ' + Input.join(', ');
                    }
                }
            }

            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-primary'}>{Name + Input}</span>
                    </div>
                </>
            )
        }
    }

    handleBtnClick = (name,e,label,value) => {

        const {type} = this.state;

        if(label === "Add New"){

            if(type === 'auto-reply'){
                window.location.href = "#/chatbot/new";
            }else{
                this.toggleActionsModal(true);
            }
        }else if(label === "Disable" || label === 'Enable'){
            this.changeStatus(name, label, value);
        }
    }

    changeStatus = async (filed, label, value) => {
        let data = {"Auto_Reply_Status" : value};
        let formname = "table_21_frm";
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "FORMINPUT" : data,
                "isOtherApiReq" : true,
                "FORMNAME" : formname,
                "OPERATION" : 'AUTO_REPLY_UPDATE',
                "FILED" : filed,
            }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            this.getInboxSettingsDetails();
            let msgLabel = "Chatbot "+label.toLowerCase()+"d";
            showToast(msgLabel +" successfully!",'top-right','success');
        }else{
            handleErrorResponse(response.errormsg);
            showToast(label +" Not successfully!",'top-right','error');
        }
    }

    toggleActionsModal = async (showActionModal,id='',updateList=false) => {
        this.setState({ showActionModal, quickReplyId : id });

        if(updateList){
            await this.loadFormData();
        }
    }

    initiateEditQuickReply = async(e, quickReplyId) => {

        const { type } = this.state;

        if(type === "auto-reply"){
            window.location.href = "#/chatbot/edit/"+quickReplyId;
        }else{
            this.toggleActionsModal(true,quickReplyId);
        }
    }

    onQuickReplyDelete = () => {
        showToast("Deleted Successfully!",'top-right','success');
        this.loadFormData();
    }

    render() {

        let { formData, listFields, page, totalCount, limit, showActionModal, quickReplyId, type,inboxStatus } = this.state;
        let quickReplyHeader = 'Create quick replies';
        let quickReplyDesc = 'Quick replies can be created to easily reuse frequently sent messages.';
        let autoReplyHeader = 'Automate conversations with users';
        let autoReplyDesc = 'Enhance the user experience for your customers with quick and personalized answers to their queries.';

        if(listFields === undefined){
            return <></>;
        }

        let createBtnLabel = 'Add New';
        let msgStatusBtn = 'hide';
        let customFieldConfig = {
            Message:{
                "class": "template-message",
                "decodeWithParse" : true,
                "render" : "msgGroup"
            },
            Title : {
                "render" : "groupName",
                "class": "template-name",
            },
            Name : {
                "render" : "groupName",
                "class" : "text-left"
            },
            Input : {
                "render" : "InputValue",
                "class" : "text-left"
            },

        };
        let headerFieldConfig = {
            Title : {
                "class" : "text-left"
            },
            Name : {
                "class" : "text-left"
            },
            Message : {
                "class" : "text-left w-1"
            }
        };
        let customRowConfig = {
            link : {
                onClick : this.initiateEditQuickReply,
                condition : "",
                class : "row-link"
            }
        }

        if(type === 'auto-reply'){
            createBtnLabel = 'Add New';
            msgStatusBtn = ''
            listFields =[['Name','Input'],['Title','Input']];

            headerFieldConfig = {
                "Name" : {
                    "class" : "text-left w-2-2"
                },
                'Input' : {
                    "class" : "text-left w-2-2"
                }
            };
        } else if(type === 'quick-reply'){
            createBtnLabel = 'Add New';
            msgStatusBtn = ''
            listFields =[['Name','Auto Response Message'],['Name','Message']];

            headerFieldConfig = {
                "Name" : {
                    "class" : "text-left"
                },
                "Auto Response Message" : {
                    "class" : "text-left w-1"
                }
            };
        }

        let buttonOptions = [
            {
                name : 'auto-reply',
                label : inboxStatus === "Yes" ? "Disable" : "Enable",
                icon : "",
                className : msgStatusBtn,
                value : inboxStatus === "Yes" ? "No" : "Yes",
            },
            {
                name : 'Quick Reply',
                label : createBtnLabel,
                icon : faCirclePlus,
            }
        ];
        let quickButtonOptions = [
            {
                name : 'Quick Reply',
                label : createBtnLabel,
                icon : faCirclePlus,
            }
        ]

        return (
            <Fragment>
                <div className="listview-container templates-listview kv-main-wrapper h100per">
                    <FormHeader
                        buttonOptions={type === 'quick-reply' ? quickButtonOptions : buttonOptions}
                        handleBtnClick={this.handleBtnClick}
                        headerText = {type === 'quick-reply' ? quickReplyHeader : autoReplyHeader}
                        headerDesc = {type === 'quick-reply' ? quickReplyDesc : autoReplyDesc}
                    />
                    <div className={'mb-2'}>
                        <ListTable
                            key={Math.random()}
                            formData={formData}
                            fields={listFields}
                            showRowCount={true}
                            spaceBfCell={false}
                            isActionsNeeded={true}
                            isDeleteNeeded={true}
                            deleteCallBack={this.onQuickReplyDelete}
                            config={customFieldConfig}
                            customRowConfig={customRowConfig}
                            renderElements={this.renderElements}
                            noDataMsg={`Quick Reply not found`}
                            pagination={true}
                            onPageChange={this.onPageChange}
                            currentPage={page}
                            totalCount={totalCount}
                            limit={limit}
                            prefix = {"quickreply"}
                            customClass={'no-border-table'}
                            headerConfig={headerFieldConfig}
                            formName={this.formname}
                        />
                    </div>
                    {
                        type === "quick-reply" &&
                        <QuickReplyOperations
                            key={randstr('quickrep_')}
                            showActionModal={showActionModal}
                            quickReplyId={quickReplyId}
                            toggleActionsModal={this.toggleActionsModal}
                            type={type}
                            useForm={this.props.useForm}
                        />
                    }
                </div>
            </Fragment>
        )
    }

}

export default QuickReply;
